module.exports = __webpack_public_path__ + "./images/b5b48d8ec1ca535934602fc12814afe2.webp";